import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/PageResetPassword.css";

function PageResetPassword() {
	const { token } = useParams();
	const [valid, setValid] = useState(false);
	const [loading, setLoading] = useState(true);
	const [newPassword, setNewPassword] = useState("");
	const [message, setMessage] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_API_URL}/api/auth/reset/${token}`)
			.then(() => {
				setValid(true);
				setLoading(false);
			})
			.catch(() => {
				setValid(false);
				setLoading(false);
				setMessage("Nieprawidłowy lub wygasły token resetujący.");
			});
	}, [token]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setMessage("");

		try {
			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}/api/auth/reset/${token}`,
				{ newPassword }
			);

			if (res.status === 200) {
				setMessage("Hasło zmienione! Zaraz zostaniesz przekierowany...");
				setTimeout(() => navigate("/login"), 3000);
			}
		} catch (err) {
			if (err.response) {
				setMessage(err.response.data?.message || "Błąd zmiany hasła.");
			} else if (err.request) {
				setMessage("Brak odpowiedzi z serwera.");
			} else {
				setMessage("Wystąpił błąd: " + err.message);
			}
		}
	};

	return (
		<div className="rp">
			<div className="rp-overlay">
				<div className="rp-card">
					{loading ? (
						<p className="rp-loading">Sprawdzanie tokena...</p>
					) : !valid ? (
						<p className="rp-error">{message}</p>
					) : (
						<>
							<h1 className="rp-title">Ustaw nowe hasło</h1>

							<form className="rp-form" onSubmit={handleSubmit}>
								<label className="rp-label">Nowe hasło</label>
								<input
									type="password"
									className="rp-input"
									placeholder="Wpisz nowe hasło"
									value={newPassword}
									onChange={(e) => setNewPassword(e.target.value)}
									required
								/>

								<button className="rp-button" type="submit">
									Zmień hasło
								</button>
							</form>

							{message && <p className="rp-message">{message}</p>}
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default PageResetPassword;
